import { IpStackGeoPoint } from '../../interfaces/interfaces';

// Get client device IP location to center Google Map
export default async function callIpStack(): Promise<IpStackGeoPoint | any> {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');

	// TODO: Put in config
	return await fetch('https://api.ipstack.com/check?access_key=9ea48facc51b3f7bd89043cdcffe790c&fields=latitude,longitude,region_code,city,zip&output=json', {
		method: 'GET',
		headers: headers,
	}).then(async (ipinfo: any) => {
		const result: IpStackGeoPoint = await ipinfo.json();
		return result;
	})
		.catch((error: any) => {
			console.warn('Error getting location from IP Address (service down or possibly adblocked): ', error.message);
			return undefined;
		});
}